import { FC, useState, type MouseEvent } from 'react'
import classNames from 'classnames'

import styles from './SelectLanguage.module.scss'
import { useLanguageTranslation } from 'hooks'

type TLangProps = {
  label: string
  value: string
}

const languageList: TLangProps[] = [
  { label: 'Հայ', value: 'am' },
  { label: 'Eng', value: 'en' },
  { label: 'Рус', value: 'ru' },
]

const SelectLanguage: FC = () => {
  const { language, onLanguageChangeCallback } = useLanguageTranslation()

  const [open, setOpen] = useState<boolean>(false)

  const activeLanguage =
    languageList.find(item => item.value === language?.split('-')[0]) || languageList[0]

  const handleLanguageChange = (event: MouseEvent<HTMLSpanElement>, value: string) => {
    event.stopPropagation()
    onLanguageChangeCallback(value)
    setOpen(false)
  }

  const openHandler = () => {
    setOpen(prev => !prev)
  }

  return (
    <div className={styles.language} role='button' onClick={openHandler}>
      <span>{activeLanguage.label}</span>
      <span className={styles.language__chevron} aria-hidden />
      {open && (
        <div className={styles.language__list}>
          {languageList.map(item => (
            <span
              key={item.value}
              onClick={event => handleLanguageChange(event, item.value)}
              className={classNames(styles.language__list_item, {
                [styles.language__list_item_active]: item.value === activeLanguage.value,
              })}
            >
              {item.label}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}

export default SelectLanguage
